import ToastDialog from "components/Common/ToastDialog";
import { FieldArray, Form, FormikProvider, useFormik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import {
  Button,
  Card,
  Col,
  FormFeedback,
  Input,
  Row,
  Label,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  UncontrolledTooltip,
} from "reactstrap";
import * as Yup from "yup";


//Import Breadcrumb
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { addAuthorisedPerson, deleteAuthorisedPersonList, editAuthorisedPerson, editAuthorisedPersonStatus, getAuthorisedPersonList } from "http/fundLync/entityAndAddress.helper";
import { formatDateString, formatDateString1 } from "./borrowingProfile";
import { decryptedValue, isPermission } from "common/utility";
import API_SERVICES from "constants/app.constants";
import TableContainerV1 from "components/Common/TableContainerV1";
import CommonDialog from "components/Common/CommonDialog";

const TableRow = ({ onDelete, onItemSelect, index, validation }) => {
  const [partnerType, setPartnerType] = useState([]);
  const genderOptions = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];
  useEffect(() => {
    getDropDownList({ dropdownName: "partner" })
      .then((response) => {
        const dropdownValues = response.data?.rows?.find((dv) => dv.dropdownName == "partner")?.dropdownValues || []
        setPartnerType(dropdownValues);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const currentDate = new Date().toISOString().split("T")[0];

  const handleInputChange = (index, field, value) => {
    validation.setFieldValue(`partnerList.${index}.${field}`, value);
  };

  return (
    <div className="mb-3 row">
      <Col sm="12" md="12" className="mb-3 d-flex justify-content-end">
        {validation.values?.partnerList?.length > 1 && (
          <i
            className="bx bx-x-circle text-danger"
            onClick={() => onDelete(validation.values.partnerList[index], index)}
            style={{ cursor: "pointer", fontSize: "17px", marginTop: "10px" }}
          />
        )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].firstName`}>First Name </Label>
        <Input
          type="text"
          placeholder="Enter Partner First Name"
          name={`[${index}].firstName`}
          id={`[${index}].firstName`}
          value={validation.values?.partnerList[index]?.firstName}
          onChange={(e) =>
            handleInputChange(index, "firstName", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.firstName &&
            validation.errors.partnerList?.[index]?.firstName
          }
        />
        {validation.touched.partnerList?.[index]?.firstName &&
          validation.errors.partnerList?.[index]?.firstName && (
            <FormFeedback>
              {validation.errors.partnerList[index]?.firstName}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].lastName`}>Last Name </Label>
        <Input
          type="text"
          placeholder="Enter Partner Last Name"
          name={`[${index}].lastName`}
          id={`[${index}].lastName`}
          value={validation.values?.partnerList[index]?.lastName}
          onChange={(e) =>
            handleInputChange(index, "lastName", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.lastName &&
            validation.errors.partnerList?.[index]?.lastName
          }
        />
        {validation.touched.partnerList?.[index]?.lastName &&
          validation.errors.partnerList?.[index]?.lastName && (
            <FormFeedback>
              {validation.errors.partnerList[index]?.lastName}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].email`}>Email </Label>
        <Input
          type="email"
          placeholder="Enter Email"
          name={`[${index}].email`}
          id={`[${index}].email`}
          value={validation.values?.partnerList[index]?.email}
          onChange={(e) =>
            handleInputChange(index, "email", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.email &&
            validation.errors.partnerList?.[index]?.email
          }
        />
        {validation.touched.partnerList?.[index]?.email &&
          validation.errors.partnerList?.[index]?.email && (
            <FormFeedback>
              {validation.errors.partnerList[index]?.email}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].mobile`}>Mobile No </Label>
        <Input
          type="text"
          placeholder="Enter Mobile No"
          name={`[${index}].mobile`}
          id={`[${index}].mobile`}
          value={validation.values?.partnerList[index]?.mobile}
          onChange={(e) =>
            handleInputChange(index, "mobile", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.mobile &&
            validation.errors.partnerList?.[index]?.mobile
          }
        />
        {validation.touched.partnerList?.[index]?.mobile &&
          validation.errors.partnerList?.[index]?.mobile && (
            <FormFeedback>
              {validation.errors.partnerList[index]?.mobile}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].dob`}>DOB</Label>
        <Input
          type="date"
          placeholder="DD/MM/YYYY"
          name={`partner[${index}].dob`}
          id={`partner[${index}].dob`}
          max={currentDate}
          value={formatDateString1(validation.values.partnerList[index].dob)}
          onChange={(e) =>
            handleInputChange(index, "dob", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.dob &&
            validation.errors.partnerList?.[index]?.dob
          }
        />
        {validation.touched.partnerList?.[index]?.dob &&
          validation.errors.partnerList?.[index]?.dob && (
            <FormFeedback>
              {validation.errors.partnerList[index].dob}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].fatherName`}>Father Name </Label>
        <Input
          type="text"
          placeholder="Enter Father's Name"
          name={`partner[${index}].fatherName`}
          id={`partner[${index}].fatherName`}
          value={validation.values.partnerList[index].fatherName}
          onChange={(e) =>
            handleInputChange(index, "fatherName", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.fatherName &&
            validation.errors.partnerList?.[index]?.fatherName
          }
        />
        {validation.touched.partnerList?.[index]?.fatherName &&
          validation.errors.partnerList?.[index]?.fatherName && (
            <FormFeedback>
              {validation.errors.partnerList[index].fatherName}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].pan`}>PAN </Label>
        <Input
          type="text"
          placeholder="Enter PAN"
          name={`partner[${index}].pan`}
          id={`partner[${index}].pan`}
          value={validation.values.partnerList[index].pan}
          onChange={(e) =>
            handleInputChange(index, "pan", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.pan &&
            validation.errors.partnerList?.[index]?.pan
          }
        />
        {validation.touched.partnerList?.[index]?.pan &&
          validation.errors.partnerList?.[index]?.pan && (
            <FormFeedback>
              {validation.errors.partnerList[index].pan}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].adharNo`}>Adhar No</Label>
        <Input
          type="text"
          placeholder="Enter Adhar No"
          name={`partner[${index}].adharNo`}
          id={`partner[${index}].adharNo`}
          value={validation.values.partnerList[index].adharNo}
          onChange={(e) =>
            handleInputChange(index, "adharNo", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.adharNo &&
            validation.errors.partnerList?.[index]?.adharNo
          }
        />
        {validation.touched.partnerList?.[index]?.adharNo &&
          validation.errors.partnerList?.[index]?.adharNo && (
            <FormFeedback>
              {validation.errors.partnerList[index].adharNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].voterId`}>Voter Id</Label>
        <Input
          type="text"
          placeholder="Enter Voter Id"
          name={`partner[${index}].voterId`}
          id={`partner[${index}].voterId`}
          value={validation.values.partnerList[index].voterId}
          onChange={(e) =>
            handleInputChange(index, "voterId", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.voterId &&
            validation.errors.partnerList?.[index]?.pan
          }
        />
        {validation.touched.partnerList?.[index]?.voterId &&
          validation.errors.partnerList?.[index]?.voterId && (
            <FormFeedback>
              {validation.errors.partnerList[index].voterId}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].passportNo`}>Passport No</Label>
        <Input
          type="text"
          placeholder="Enter Passport No"
          name={`partner[${index}].passportNo`}
          id={`partner[${index}].passportNo`}
          value={validation.values.partnerList[index].passportNo}
          onChange={(e) =>
            handleInputChange(index, "passportNo", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.passportNo &&
            validation.errors.partnerList?.[index]?.passportNo
          }
        />
        {validation.touched.partnerList?.[index]?.passportNo &&
          validation.errors.partnerList?.[index]?.passportNo && (
            <FormFeedback>
              {validation.errors.partnerList[index].passportNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].rationCardNo`}>Ration Card No</Label>
        <Input
          type="text"
          placeholder="Enter Ration Card No"
          name={`partner[${index}].rationCardNo`}
          id={`partner[${index}].rationCardNo`}
          value={validation.values.partnerList[index].rationCardNo}
          onChange={(e) =>
            handleInputChange(index, "rationCardNo", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.rationCardNo &&
            validation.errors.partnerList?.[index]?.rationCardNo
          }
        />
        {validation.touched.partnerList?.[index]?.rationCardNo &&
          validation.errors.partnerList?.[index]?.rationCardNo && (
            <FormFeedback>
              {validation.errors.partnerList[index].rationCardNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].nregaNo`}>NREGA No</Label>
        <Input
          type="text"
          placeholder="Enter NREGA No"
          name={`partner[${index}].nregaNo`}
          id={`partner[${index}].nregaNo`}
          value={validation.values.partnerList[index].nregaNo}
          onChange={(e) =>
            handleInputChange(index, "nregaNo", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.nregaNo &&
            validation.errors.partnerList?.[index]?.nregaNo
          }
        />
        {validation.touched.partnerList?.[index]?.nregaNo &&
          validation.errors.partnerList?.[index]?.nregaNo && (
            <FormFeedback>
              {validation.errors.partnerList[index].nregaNo}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].ckyc`}>CKYC</Label>
        <Input
          type="text"
          placeholder="Enter CKYC"
          name={`partner[${index}].ckyc`}
          id={`partner[${index}].ckyc`}
          value={validation.values.partnerList[index].ckyc}
          onChange={(e) =>
            handleInputChange(index, "ckyc", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.ckyc &&
            validation.errors.partnerList?.[index]?.ckyc
          }
        />
        {validation.touched.partnerList?.[index]?.ckyc &&
          validation.errors.partnerList?.[index]?.ckyc && (
            <FormFeedback>
              {validation.errors.partnerList[index].ckyc}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].drivingLicense`}>Driving License No</Label>
        <Input
          type="text"
          placeholder="Enter Driving License No"
          name={`partner[${index}].drivingLicense`}
          id={`partner[${index}].drivingLicense`}
          value={validation.values.partnerList[index].drivingLicense}
          onChange={(e) =>
            handleInputChange(index, "drivingLicense", e.target.value)
          }
          invalid={
            validation.touched.partnerList?.[index]?.drivingLicense &&
            validation.errors.partnerList?.[index]?.drivingLicense
          }
        />
        {validation.touched.partnerList?.[index]?.drivingLicense &&
          validation.errors.partnerList?.[index]?.drivingLicense && (
            <FormFeedback>
              {validation.errors.partnerList[index].drivingLicense}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].gender`}>Select Gender</Label>
        <Select
          options={genderOptions}
          placeholder={'Select Gender'}
          className={`select-dropdown ${validation.touched.partnerList?.[index]?.gender &&
            validation.errors.partnerList?.[index]?.gender
            ? "is-invalid"
            : ""
            }`}
          name={`partner[${index}].gender`}
          id={`partner[${index}].gender`}
          onChange={(selectedOption) => {
            handleInputChange(index, "gender", selectedOption.value);
          }}
          value={setGender(
            genderOptions,
            validation.values.partnerList[index].gender
          )}
        />
        {validation.touched.partnerList?.[index]?.gender &&
          validation.errors.partnerList?.[index]?.gender && (
            <FormFeedback>
              {validation.errors.partnerList?.[index]?.gender}
            </FormFeedback>
          )}
      </Col>
      <Col sm="12" md="6" className="mb-3">
        <Label htmlFor={`[${index}].partnerType`}>Select Partner Type </Label>
        <Select
          options={partnerType.map((option, index) => ({
            label: option.displayName,
            value: option.dropdownValue,
          }))}
          placeholder={'Select Partner Type'}
          className={`select-dropdown ${validation.touched.partnerList?.[index]?.partnerType &&
            validation.errors.partnerList?.[index]?.partnerType
            ? "is-invalid"
            : ""
            }`}
          name={`partner[${index}].partnerType`}
          id={`partner[${index}].partnerType`}
          onChange={(selectedOption) => {
            handleInputChange(index, "partnerType", selectedOption.value);
          }}
          value={setpartnerInitialType(
            partnerType,
            validation.values.partnerList[index].partnerType
          )}
        />
        {validation.touched.partnerList?.[index]?.partnerType &&
          validation.errors.partnerList?.[index]?.partnerType && (
            <FormFeedback>
              {validation.errors.partnerList?.[index]?.partnerType}
            </FormFeedback>
          )}
      </Col>
    </div>
  );

  function setpartnerInitialType(data, type) {
    if (type) {
      for (const item of data) {
        if (item.dropdownValue === type) {
          const value = { label: `${item.displayName}`, value: type };
          return value;
        }
      }
    }
  }
  function setGender(data, gender) {
    if (gender) {
      for (const item of data) {
        if (item.value === gender) {
          const value = { label: `${item.label}`, value: gender };
          return value;
        }
      }
    }
  }
};

const Partners = (props) => {
  // document.title = "Partners | FundLync";

  const [rows, setRows] = useState([
    {
      firstName: "",
      lastName: "",
      dob: "",
      fatherName: "",
      partnerType: "",
      email: "",
      mobile: "",
      adharNo: "",
      voterId: "",
      passportNo: "",
      rationCardNo: "",
      nregaNo: "",
      ckyc: "",
      drivingLicense: "",
      pan: "",
      gender: ""
    },
  ]);
  const [partnerArrayList, setPartnerArrayList] = useState([]);
  const [toastInfo, setToastInfo] = useState({ showToast: false });
  const [isAddPartnerPermission, setAddPartnerPermission] = useState(false);
  const [isEditPartnerPermission, setEditPartnerPermission] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedDirectorIndex, setSelectedDirectorIndex] = useState(null);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageCount: 0,
    totalRecords: 0,
  });
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [columnId, setColumnId] = useState("id");
  const [sortingOrderStatus, setSortingOrderStatus] = useState("desc");
  const [isNewEntityPermission, setIsNewEntityPermission] = useState(false);
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const userObj = decryptedValue(localStorage.getItem("user")) || "{}";
  const { entityType } = userObj || "";
  const [sortingOptions, setSortingOptions] = useState({
    column: "id",
    isAsc: false,
    optionalColumn: ["Action"],
  });

  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };

  const urlParams = new URLSearchParams(window.location.search);
  // const encodedId = urlParams.get("id");
  // const entityId = atob(encodedId);

  const filterType = urlParams.get("filter");
  let decodeFilterType = isBase64(filterType) ? atob(filterType) : filterType;
  const [entityId, setEntityId] = useState('')
  const [encodedId, setEncodedId] = useState('')

  useEffect(()=>{
    const userDetails = decryptedValue(localStorage.getItem("user"));
      if(userDetails.entityType === "Partner" || userDetails.entityType === "Owner"){
        setEncodedId(urlParams.get("id"))
        setEntityId(atob(encodedId))
      }else{
        setEncodedId(entityId)
        setEntityId(userDetails.entityId)
      }
  },[ entityId, encodedId])
  
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "First Name",
        accessor: "firstName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Last Name",
        accessor: "lastName",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: (cellProps) => {
          return cellProps.value || "";
        },
      },
      {
        Header: "Mobile",
        accessor: "mobile",
        filterable: true,
        Cell: (cellProps) => {
          return `${cellProps.value || ""}`;
        },
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          const rowData = cellProps.row.original;
          return (
            <TableActionsComponent
              {...rowData}
              setSelectedDirectorIndex={setSelectedDirectorIndex}
              partnerArrayList={partnerArrayList} // Pass directorArrayList as a prop
              setSelectedDirector={setSelectedDirector}
              toggleEditMode={toggleEditMode}
              deleteDetail={deleteDetail}
            />
          );
        },
      },
    ],
    [partnerArrayList]
  );

  // useEffect(() => {
  const getPartnersList = (data, entityId) => {
    getAuthorisedPersonList({ ...data, entityId, type: "partner" })
      .then((response) => {
        if (response.status && response.code === 200) {
          const allPartners = response.data.data || [];
          if (allPartners.length > 0) {
            setPartnerArrayList(allPartners);
            setRows(allPartners);
          }
          const { totalItems, totalPages, currentPage } = response.data;
          setPagination({
            pageIndex: currentPage,
            pageCount: totalPages,
            totalRecords: totalItems,
          });
        }
        else {
          setPartnerArrayList([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }

  // }, []);

  const handlePageChange = (
    page,
    pageSize,
    searchKey,
    columnName = columnId,
    sortingOrder = sortingOrderStatus
  ) => {
    setPageSize(pageSize);
    const data = {
      page,
      limit: pageSize,
      searchKey,
      columnName,
      sortingOrder,
    };
    if (filterType) {
      data.filterType = decodeFilterType;
    }
    getPartnersList(data, entityId);
  };

  const handleSortColumn = (option) => {
    setSortingOptions(option);
    const columnName = option.column;
    setColumnId(columnName);
    const sortingOrder = option.isAsc ? "asc" : "desc";
    setSortingOrderStatus(sortingOrder);
    handlePageChange(1, pageSize, searchValue, columnName, sortingOrder);
  };

  const handleSearchFilter = (value, pageSize) => {
    if (filterType) {
      if (value) {
        setSearchValue(value);
        handlePageChange(1, pageSize, value);
      } else {
        setSearchValue(decodeFilterType);
        handlePageChange(1, pageSize, decodeFilterType);
      }
    } else {
      setSearchValue(value);
      handlePageChange(1, pageSize, value);
    }
  };

  const handleClearSearch = () => {
    if (filterType) {
      setSearchValue(decodeFilterType);
      handlePageChange(1, pageSize, decodeFilterType);
    } else {
      setSearchValue("");
      handlePageChange(1, pageSize, "");
    }
  };

  useEffect(() => {
    if (entityId) {
      if (filterType) {
        getPartnersList({ searchKey: `${decodeFilterType}` }, entityId);
      } else {
        getPartnersList({}, entityId);
      }
    }
  }, [entityId, filterType]);

  useEffect(() => {
    checkPermissions();
  }, []);

  const toggleEditMode = () => {
    setEditMode(!editMode);
  };

  const handleBackClick = () => {
    setSelectedDirectorIndex(null);
    setSelectedDirector(null);
  };

  const checkPermissions = async () => {
    const addPartnerpermission = await isPermission(
      "authorised_person",
      "create_permission"
    );
    const editPartnerpermission = await isPermission(
      "authorised_person",
      "edit_permission"
    );

    setAddPartnerPermission(addPartnerpermission);
    setEditPartnerPermission(editPartnerpermission);
  };


  const handleDelete = (rowIndex, index) => {
    if (rowIndex.id) {
      editAuthorisedPersonStatus({ id: rowIndex.id, status: 0 })
    }
    validation.values.partnerList.splice(index, 1);
    validation.validateForm();
  };

  const handleItemSelect = (data, value) => {
    data.type = value;
    validation.setFieldValue("type", value);
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      partnerList: selectedDirector
        ? [selectedDirector] : [
          {
            firstName: "",
            lastName: "",
            dob: null,
            fatherName: "",
            pan: "",
            partnerType: "",
            email: "",
            mobile: "",
            adharNo: "",
            voterId: "",
            passportNo: "",
            rationCardNo: "",
            nregaNo: "",
            ckyc: "",
            drivingLicense: "",
            gender: ""
          },
        ],
    },
    validationSchema: Yup.object({
      partnerList: Yup.array().of(
        Yup.object({
          firstName: Yup.string().nullable(),
          lastName: Yup.string().nullable(),
          partnerType: Yup.string().nullable(),
          fatherName: Yup.string().nullable(),
          pan: Yup.string().matches(API_SERVICES.PAN_PATTERN, "Enter a valid PAN number").nullable(),
          dob: Yup.date().nullable().notRequired(),
          email: Yup.string().nullable().nullable(),
          gender: Yup.string().nullable().nullable(),
          mobile: Yup.string().nullable().nullable()
            .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits"),
          adharNo: Yup.string().nullable().matches(/^\d{12}$/, "Aadhar Number must be exactly 12 digits when provided"),
          voterId: Yup.string().nullable(),
          passportNo: Yup.string().nullable(),
          rationCardNo: Yup.string().nullable(),
          nregaNo: Yup.string().nullable(),
          ckyc: Yup.string().nullable(),
          drivingLicense: Yup.string().nullable()
        })
      ),
    }),
    onSubmit: (values) => {
      let partnerDatas = [...values.partnerList]
      for (let value of partnerDatas) {
        value.entityId = entityId
        value.type = "partner"
        if (!value.dob) {
          value.dob = null;
        }
      }
      if (!selectedDirector) {
        addAuthorisedPerson({ "authorisedPerson": partnerDatas })
          .then((response) => {
            setEditMode(false);
            if ((response.code == 201 && response.status)) {
              setToastInfo({
                message: "Partner Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        editAuthorisedPerson(values.partnerList)
          .then((response) => {
            if ((response.code == 201 && response.status)) {
              setEditMode(false);
              setToastInfo({
                message: "Partner Saved",
                showToast: true,
                role: "success",
              });
              callAfterSave();
            } else {
              const { message } = response;
              setToastInfo({
                message: message,
                showToast: true,
                role: "error",
              });
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  });

  const callAfterSave = () => {
    getAuthorisedPersonList({ entityId, type: "partner" })
      .then((response) => {
        const allPartners = response?.data?.data || [];
        // if (allPartners.length > 0) {
          setPartnerArrayList(allPartners);
          setRows(allPartners);
          setSelectedDirector(null);
          setSelectedDirectorIndex(null);
        // }
        const { totalItems, totalPages, currentPage } = response.data;
        setPagination({
          pageIndex: currentPage,
          pageCount: totalPages,
          totalRecords: totalItems,
        });
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const deleteDetail = (id) => {
    const message = 'Are you sure you want to delete this data?'
    const data = {id}
    setShowCommonDialog({ isShow: true, message, data })
  };
  
  const dialogActionAccept = (action, data) => {
    if (action == 1) {
        setShowCommonDialog({ isShow: false })
        deleteAuthorisedPersonList({id : data.id})
        .then((response) => {
          if (response.code == 201 && response.status) {
            setToastInfo({
              message: "Director Information Deleted Succesfully",
              showToast: true,
              role: "success",
            });
            callAfterSave();
          } else {
            const { message } = response;
            setToastInfo({
              message: message,
              showToast: true,
              role: "error",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
        setShowCommonDialog({ isShow: false })
    }
  }

  //meta title

  return (
    <React.Fragment>
      <Row>
        <Col sm="12">
          <Card className="p-3">
            <div className="text-end mb-3">
              <div onClick={toggleEditMode} style={{ cursor: "pointer" }}>
                {editMode ?
                  <div className="text-sm-end">
                    <Button
                      type="button"
                      color="outline-success"
                      className="btn-rounded mb-2 me-2"
                    >
                      close
                    </Button>
                  </div>
                  :
                  <div className="d-flex justify-content-end">
                    <Button
                      type="button"
                      style={{ backgroundColor: '#21aa47', borderColor: '#21aa47', color: '#fff' }}
                      className="mb-3 me-2"
                      onClick={() => {
                        setEditMode(true);
                        setSelectedDirector(null);
                      }}
                    >
                      <i className="fas fa-plus me-2"></i>
                      <span >
                        {" "}
                        Add Partner
                      </span>
                    </Button>
                  </div>}
              </div>
            </div>

            {editMode ? (
              <FormikProvider value={validation}>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();

                    return false;
                  }}
                >
                  <Row className="mb-3">
                    <FieldArray
                      name="partnerList"
                      render={(arrayHelpers) => (
                        <>
                          {validation.values.partnerList.map(
                            (partner, index) => (
                              <TableRow
                                key={partner.id}
                                onDelete={handleDelete}
                                onItemSelect={handleItemSelect}
                                index={index}
                                validation={validation}
                              />
                            )
                          )}
                          {selectedDirector === null && (
                            <tr>
                              <td colSpan={6}>
                                <span
                                  className="text-success"
                                  style={{ cursor: "pointer" }}
                                  onKeyUp={() => { }}
                                  onClick={() => {
                                    arrayHelpers.push({
                                      firstName: "",
                                      lastName: "",
                                      dob: "",
                                      fatherName: "",
                                      pan: "",
                                      partnerType: "",
                                      email: "",
                                      mobile: "",
                                      adharNo: "",
                                      voterId: "",
                                      passportNo: "",
                                      rationCardNo: "",
                                      nregaNo: "",
                                      ckyc: "",
                                      drivingLicense: "",
                                      gender: ""
                                    });
                                  }}
                                >
                                  <i className="mdi mdi-plus me-1" /> Add Partner
                                </span>
                              </td>
                            </tr>
                          )}
                        </>
                      )}
                    />
                  </Row>
                  <Row>
                    <Col>
                      <div className="text-end">
                        {(partnerArrayList.length == 0 ? isAddPartnerPermission : isEditPartnerPermission) && <button type="submit" className="btn btn-success">
                          Save
                        </button>}
                      </div>
                    </Col>
                  </Row>
                </Form>
              </FormikProvider>
            ) : selectedDirectorIndex === null ? (
              <TableContainerV1
                columns={columns}
                data={partnerArrayList}
                pagination={pagination}
                handlePageChange={handlePageChange}
                handleSearchFilter={handleSearchFilter}
                sortOptions={sortingOptions}
                handleSortColumn={handleSortColumn}
                handleClearSearch={handleClearSearch}
                className="custom-header-css"
              />
            ) : (
              <div>
                <Row className="mt-1">
                  <Col>
                    <div className="font-size-14">
                      <b>{selectedDirectorIndex + 1}. Partner Details</b>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Partner First Name</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).firstName || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Partner Last Name</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).lastName || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Email</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).email || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Mobile No.</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).mobile || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">date of Birth</Label>
                    <span className="mb-0 entityDetailsValue">{formatDateString(partnerArrayList.find(d => d.id === selectedDirectorIndex).dob) || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Father's Name</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).fatherName || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Pan</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).pan || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Adhar Number</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).adharNo || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Voter Id</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).voterId || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Passport Number</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).passportNo || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Ration Card Number</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).rationCardNo || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">NREGA No</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).nregaNo || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">CKYC</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).ckyc || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Driving License Number</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).drivingLicense || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Gender</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).gender || "-"}</span>
                  </Col>
                  <Col sm="6" md="4" lg="3" className="mb-3 mt-3">
                    <Label className="d-block entityDetails">Partner Type</Label>
                    <span className="mb-0 entityDetailsValue">{partnerArrayList.find(d => d.id === selectedDirectorIndex).partnerType || "-"}</span>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-end">
                    <Button style={{ backgroundColor: "#21aa47", borderColor: "#21aa47", color: "white" }} onClick={handleBackClick}>
                      Back
                    </Button>
                  </Col>
                </Row>
              </div>

            )}
          </Card>
        </Col>
      </Row>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
      {
        showCommonDialog &&
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message} data={showCommonDialog.data}
          postitiveBtn={'Yes'} negativeBtn={'No'} onCloseFn={dialogActionAccept}
        />
      }
    </React.Fragment>
  );
};

const TableActionsComponent = ({ id, partnerArrayList, setSelectedDirectorIndex, setSelectedDirector, toggleEditMode, deleteDetail }) => {
  const handleViewClick = (index) => {
    setSelectedDirectorIndex(index);
  };

  const handleEditClick = (index) => {
    const selectedDirectorData = partnerArrayList.find((director) => director.id === id);
    setSelectedDirector(selectedDirectorData);
    toggleEditMode();
  };


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-horizontal font-size-18"></i>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => handleViewClick(id)}>
          <i
            className="mdi mdi-eye font-size-16 text-success me-1"
            id={`viewtooltip_${id}`}
          ></i>
          View
          <UncontrolledTooltip placement="top" target={`viewtooltip_${id}`}>
            View
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem onClick={() => handleEditClick(id)}>
          <i
            className="mdi mdi-pencil font-size-16 text-success me-1"
            id={`edittooltip_${id}`}
          ></i>
          Edit
          <UncontrolledTooltip placement="top" target={`edittooltip_${id}`}>
            Edit
          </UncontrolledTooltip>
        </DropdownItem>
        <DropdownItem
          onClick={() => {
            deleteDetail(id);
          }}
        >
          <i
            className="mdi mdi-delete font-size-16 text-success me-1"
            id="deletetooltip"
          ></i>
          Delete
          <UncontrolledTooltip
            placement="top"
            target="deletetooltip"
          >
            Delete
          </UncontrolledTooltip>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default Partners;
